export enum GitEventFieldKeys {
    InitialCommitBranch = "Initial Commit Branch",
    ProtectedBranches = "Protected Branches",
    IsDefaultBranch = "Is Default Branch",
    CommitMessage = "Commit Message"
}
